export type CompletedServiceRequest = {
    id: string;
    requestReference: string;
    serviceName: string;
    serviceCode?: string;
    deliveredAt?: string;
    status: string;
    deliveryFileCount?: number;
    deliveryReportCount?: number;
    deliveryReports?: Array<{ id: string; title: string; type?: string }>;
    deliveryDashboard?: { projectId: string; frameworkId?: string; title?: string };
    dailyMicroCountry?: string;
};

export function serviceDeliveryWorkspace(request: CompletedServiceRequest): 'ep-project' | 'travel-dashboard' | 'srm-dashboard' | null {
    if (['EP-10', 'S-10'].includes(request.serviceCode || '') || /(executive protection|ep).*(project|operations)|project.*planner/i.test(request.serviceName))
        return 'ep-project';
    if (request.serviceCode === 'TRM-01' || /travel.*(security|brief|dashboard)/i.test(request.serviceName))
        return 'travel-dashboard';
    if (['S-02', 'S-04'].includes(request.serviceCode || '') && request.deliveryDashboard?.projectId)
        return 'srm-dashboard';
    return null;
}

export function isCompletedServiceDelivery(request: CompletedServiceRequest): boolean {
    const delivered = ['delivered', 'invoiced', 'completed'].includes(request.status) || Boolean(request.deliveredAt);
    return delivered && (Number(request.deliveryReportCount || 0) > 0 || serviceDeliveryWorkspace(request) !== null
        || request.serviceCode === 'S-07' && Boolean(request.dailyMicroCountry));
}
